
export type Account = {
  company_id?: string;
  region: string;
  country: string;
  company_name: string;
  parent_company?: string;
  industry: string;
  account_manager: string;
};

export type FinancialData = {
  labels: string[];
  revenue: number[];
  profit: number[];
  eps: number[];
  cashFlow: number[];
  debt: number[];
  ebitdaMargins: number[];
};

export const emptyChartData: FinancialData = {
  labels: [],
  revenue: [],
  profit: [],
  eps: [],
  cashFlow: [],
  debt: [],
  ebitdaMargins: []
};
